export function analyticsTrackEvent(
  name: string,
  value?: string,
  unit?: string
): void {
  if (!name || typeof (<any>window).pa !== 'object') {
    return;
  }

  let obj:Record<string, any> = {};
  obj = { ...obj, name };

  if (value) {
    obj = { ...obj, value };
  }
  if (unit) {
    obj = { ...obj, unit };
  }

  (<any>window).pa.track({...obj});
}

export function analyticsTrackQuoteProfit(
  name: string,
  value: string | number,
  currency?: string
): void {

  const unit = (currency || 'EUR');
  const profit = calculatePotentialProfit(value);

  analyticsTrackEvent(name, profit, unit);
}

export function calculatePotentialProfit(
  value: string | number
): string {
  const price = Number(value);
  const profit = price * 0.1 * 0.1;

  return profit.toFixed(2);
}
